export default "__VITE_ASSET__BS57MIij__"